// extracted by mini-css-extract-plugin
export default {"form-item":"ForgotPassword_form-item__pILzL","form-item-label":"ForgotPassword_form-item-label__7QRkW"};